console.log("NODE_ENV", process.env.NODE_ENV)
export const baseURL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3333' 
    : process.env.NODE_ENV === 'test' ? 'https://apinps.tiflux.com' :'https://apinps.tiflux.com'
